import React, { useEffect, useState } from 'react'
import MyJobsList from './MyJobsList'
import BookingCalendar from '../Booking/BookingCalendar'
import { useSelector } from 'react-redux'

const Jobs = () => {
    const selectedBookingListStatus = useSelector(state => state?.booking?.selectedBookingListStatus)    

  return (
    <React.Fragment>
        { 
            !selectedBookingListStatus ? ( <BookingCalendar />  ) : 
            ( <MyJobsList /> )
        }
    </React.Fragment>
)
}

export default Jobs